<div mat-dialog-title class="modal-header">
  <h4 class="modal-title">Filters</h4>
  <button mat-icon-button class="close-button" (click)="onCancel()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="divider" />
<form [formGroup]="filtersForm" class="filters-form">
  <div class="status-container">
    <h5 class="title">Status</h5>
    <div class="checkbox-container">
      <div class="checkbox-column">
        <mat-checkbox formControlName="available">Available</mat-checkbox>
        <mat-checkbox formControlName="planned">Planned</mat-checkbox>
      </div>
      <div class="checkbox-column">
        <mat-checkbox formControlName="delivered">Delivered</mat-checkbox>
        <mat-checkbox formControlName="inTransit">In Transit</mat-checkbox>
      </div>
    </div>
  </div>

  <hr class="divider divider-with-space" />

  <div class="status-container">
    <h5 class="title">Pickup State</h5>
    <mat-form-field class="chip-list input-field" appearance="outline">
      <mat-chip-grid #chipListPickup aria-label="Selected states">
        @for (state of pickupState; track state) {
          <mat-chip-row
            [removable]="removable"
            (removed)="remove(state, pickupState)"
            >
            {{ state }}
            @if (removable) {
              <mat-icon matChipRemove>cancel</mat-icon>
            }
          </mat-chip-row>
        }
        <input
          name="pickup-state-input"
          formControlName="pickupState"
          placeholder="Select State(s)..."
          appToUpperCase
          [matChipInputFor]="chipListPickup"
          [matAutocomplete]="autoPickup"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur"
          (matChipInputTokenEnd)="add($event, pickupState)"
          />
        </mat-chip-grid>
        <mat-autocomplete
          #autoPickup="matAutocomplete"
          (optionSelected)="addFromAutocomplete($event, pickupState)"
          >
          @for (state of filteredPickupStates | async; track state) {
            <mat-option
              [value]="state"
              >
              {{ state }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <hr class="divider divider-with-space" />

    <div class="status-container">
      <h5 class="title">Consignee State</h5>
      <mat-form-field class="chip-list input-field" appearance="outline">
        <mat-chip-grid #chipListConsignee aria-label="Selected states">
          @for (state of consigneeState; track state) {
            <mat-chip-row
              [removable]="removable"
              (removed)="remove(state, consigneeState)"
              >
              {{ state }}
              @if (removable) {
                <mat-icon matChipRemove>cancel</mat-icon>
              }
            </mat-chip-row>
          }
          <input
            formControlName="consigneeState"
            placeholder="Select State(s)..."
            appToUpperCase
            [matChipInputFor]="chipListConsignee"
            [matAutocomplete]="autoConsignee"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="add($event, consigneeState)"
            />
          </mat-chip-grid>
          <mat-autocomplete
            #autoConsignee="matAutocomplete"
            (optionSelected)="addFromAutocomplete($event, consigneeState)"
            >
            @for (state of filteredConsigneeStates | async; track state) {
              <mat-option
                [value]="state"
                >
                {{ state }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <hr class="divider divider-with-space" />

      <mat-dialog-actions class="action-buttons">
        <app-button
          mat-button
          (click)="onClearAll()"
          [isInverted]="true"
          [label]="'Clear All'"
          [icon]="'block'"
        ></app-button>
        <app-button
          mat-button
          (click)="onApply()"
          [label]="'Apply'"
          [icon]="'check_circle_outline'"
        ></app-button>
      </mat-dialog-actions>
    </form>
